module.exports = __webpack_public_path__ + "static/nesting-344dedbe54f819ce2da197752a393232.png";